import { render } from "./CharactersPage.vue?vue&type=template&id=79c877b8&scoped=true"
import script from "./CharactersPage.vue?vue&type=script&lang=js"
export * from "./CharactersPage.vue?vue&type=script&lang=js"

import "./CharactersPage.vue?vue&type=style&index=0&id=79c877b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c877b8"]])

export default __exports__